/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * setDNavBtn.js
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * ドロワーナビゲーションボタン
 */
const setDNavBtn = () => {
	var body = document.body;
	var DNavBtn = document.getElementById("d-nav-btn");
	var DNav = document.getElementById("site-h_d-nav");
	var DNavLinks = document.querySelectorAll("#site-h_d-nav a");
	var Overlay = document.getElementById("overlay");

	Overlay.addEventListener("click", function () {
		body.classList.toggle("open");
		DNavBtn.classList.toggle("open");
		DNav.classList.toggle("open");
	});
	DNavBtn.addEventListener("click", function () {
		body.classList.toggle("open");
		DNavBtn.classList.toggle("open");
		DNav.classList.toggle("open");
	});
	//DNavLinksをクリックしたらドロワーナビゲーションを閉じる
	DNavLinks.forEach(function (DNavLink) {
		DNavLink.addEventListener("click", function () {
			body.classList.remove("open");
			DNavBtn.classList.remove("open");
			DNav.classList.remove("open");
		});
	});
};

/**
 * Export.
 */
/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
export { setDNavBtn };
